import { ActionReducer, MetaReducer } from '@ngrx/store';

export function storageMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === '@ngrx/store/init' && typeof localStorage !== 'undefined') {
      const persistedState = localStorage.getItem('appState');
      if (persistedState) {
        try {
          return JSON.parse(persistedState);
        } catch (e) {
          console.error('Error parsing persisted state:', e);
        }
      }
    }

    const nextState = reducer(state, action);

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('appState', JSON.stringify(nextState));
    }

    return nextState;
  };
}

export const metaReducers: MetaReducer<any>[] = [storageMetaReducer];
